import StyledDivider from './SectionDividerStyles'

const SectionDivider = () => <StyledDivider variant="middle" />

export default SectionDivider
